module.exports = __webpack_public_path__ + "img/thumb-zendesk@2x.a29d53a7.png";